import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ConfirmVoteModalProps {
  choiceName: string;
  submitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** "Do you confirm your vote for …?" — big buttons, used by the kiosk and the phone ballot */
export function ConfirmVoteModal({ choiceName, submitting, onConfirm, onCancel }: ConfirmVoteModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" role="dialog" aria-modal="true">
      <div className="w-full max-w-xl space-y-6 rounded-3xl bg-background p-8 text-center shadow-2xl">
        <p className="text-2xl text-muted-foreground">¿Confirma su voto por</p>
        <p className="text-4xl font-bold">{choiceName}?</p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Button variant="outline" className="h-16 flex-1 text-xl" disabled={submitting} onClick={onCancel}>Cambiar</Button>
          <Button className="h-16 flex-1 text-xl" disabled={submitting} onClick={onConfirm}>
            {submitting && <Loader2 className="mr-2 size-5 animate-spin" />}
            Sí, confirmar voto
          </Button>
        </div>
      </div>
    </div>
  );
}
